/**
 * CookieConsent — POPIA/GDPR compliant cookie notice.
 * Only shows if consent hasn't been recorded in localStorage.
 * Necessary cookies (auth JWT) are always set — only functional ones
 * require consent.
 */
import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const CONSENT_KEY = 'oakdesk_cookie_consent';

export default function CookieConsent({ onPrivacyPolicy }) {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem(CONSENT_KEY);
    if (!stored) setVisible(true);
  }, []);

  const accept = (level) => {
    localStorage.setItem(CONSENT_KEY, JSON.stringify({
      level,
      accepted_at: new Date().toISOString(),
      version: '2026-05',
    }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cc-banner" role="dialog" aria-modal="true" aria-label="Cookie preferences">
      <div className="cc-banner__inner">
        <div className="cc-banner__content">
          <div className="cc-banner__icon">🍪</div>
          <div>
            <p className="cc-banner__text">
              We use <strong>necessary cookies</strong> only (authentication token).
              No tracking, no analytics cookies, no advertising.
              {showDetails && (
                <span className="cc-banner__detail">
                  {' '}The session token (<code>oakdesk_token</code>) is stored in your browser to keep you logged in.
                  UI preferences (sidebar state) are stored in localStorage.
                  Neither is shared with third parties.
                </span>
              )}
            </p>
            <div className="cc-banner__links">
              <button className="cc-text-btn" onClick={() => setShowDetails(v => !v)}>
                {showDetails ? 'Show less' : 'Details'}
              </button>
              {onPrivacyPolicy && (
                <button className="cc-text-btn" onClick={onPrivacyPolicy}>Privacy policy →</button>
              )}
              <button className="cc-text-btn" onClick={() => window.location.assign('/cookies')}>Cookie policy →</button>
            </div>
          </div>
        </div>
        <div className="cc-banner__actions">
          <button className="cc-btn cc-btn--accept" onClick={() => accept('necessary')}>
            Accept necessary cookies
          </button>
          <button className="cc-btn cc-btn--reject" onClick={() => accept('rejected')}>
            Reject optional
          </button>
        </div>
      </div>
    </div>
  );
}
